<script>
import navBar from "@/layouts/components/navbar/NavBarHorizontalLayout.vue";
import GeolocationInstructions from "./GeolocationInstructions.vue"
import { VueTelInput } from 'vue-tel-input'; // Importamos la librería

export default {
  name: "LocalFlow",
  components: {
    navBar,
    GeolocationInstructions,
    VueTelInput // Registramos el componente
  },
  data() {
    return {
      isSubmitted: false,
      phoneData: {
        number: null,
        countryCode: null,
        isValid: false,
        formatted: null
      },
      isPhoneConfigured: false,
      showOtpInput: false,
      otp: ['', '', '', '', '', ''],
      otpError: null,
      phoneError: null,
      isVerifying: false,
      resendTimer: 0,
      canResend: false,
      timerInterval: null,
      routerTransition: 'slide-x-transition',
      successMessage: null,
      uuid: null,
      signatureId: null,
      signatureFlowId: null,

      // Opciones para vue-tel-input
      telInputOptions: {
        mode: 'international',
        defaultCountry: 'MX', // México por defecto
        disabledFetchingCountry: false,
        enabledCountryCode: true,
        enabledFlags: true,
        preferredCountries: ['MX', 'US', 'ES', 'CO', 'AR', 'CL', 'PE'],
        onlyCountries: [], // Dejar vacío para incluir todos los países
        inputOptions: {
          placeholder: 'Ingrese su número de teléfono',
          showDialCode: true,
        },
        invalidMsg: 'Número de teléfono inválido'
      },

      // Geolocalización
      location: {
        latitude: null,
        longitude: null,
        accuracy: null
      },
      locationStatus: {
        isRequired: true,
        isLoading: false,
        error: null,
        permissionDenied: false,
        supported: true
      },

      // Modal de instrucciones de geolocalización
      showGeolocationModal: false
    }
  },
  created() {
    let signatureId = this.$route.params.uuid;
    let uuid = this.$route.params.localVerificationId;
    let signatureFlowId = this.$route.params.signatureFlowId;
    if (uuid && signatureId && signatureFlowId) {
      this.uuid = uuid;
      this.signatureId = signatureId;
      this.signatureFlowId = signatureFlowId;
    } else {
      this.$router.push("/");
    }

    this.$store.dispatch("document/getDocumentFromSignature", {uuid: signatureId})
      .then(
        document => {
          if (document.attributes.signature_flow_status === 'COMPLETED') {
            this.$router.push({
              name: 'page-signature-flow',
              params: {
                uuid: this.signatureId,
                signatureFlowId: this.signatureFlowId
              }
            });
          }
        }
      )

    // Comprobar si la geolocalización está soportada
    if (!navigator.geolocation) {
      this.locationStatus.supported = false;
      this.locationStatus.error = "Su navegador no soporta la geolocalización, necesaria para el proceso de firma.";
      console.log("Geolocation is not supported by this browser.");
    }

    this.checkPreConfiguredPhone();

    // Solicitar la geolocalización inmediatamente
    if (this.locationStatus.supported) {
      // Mostrar un mensaje sobre la necesidad de la ubicación
      this.$vs.notify({
        color: 'primary',
        title: 'Ubicación necesaria',
        text: 'Para continuar con el proceso de firma, por favor permita el acceso a su ubicación cuando se le solicite.',
        position: 'top-center',
        time: 5000
      });

      this.requestGeolocation();
    }
  },
  computed: {
    validPhone() {
      return this.phoneData.isValid;
    },
    otpComplete() {
      return this.otp.every(digit => digit !== '');
    },
    formattedPhone() {
      return this.phoneData.formatted || '';
    },
    formatOtp() {
      return this.otp.join('');
    },
    canProceedToNextStep() {
      // Verifica si podemos continuar (teléfono válido y ubicación si es requerida)
      return this.validPhone && (!this.locationStatus.isRequired || (this.location.latitude && this.location.longitude));
    },
    currentBrowser() {
      return this.detectBrowser();
    },
    isMobileDevice() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
  },
  methods: {
    // Método para manejar el cambio en el input del teléfono
    onPhoneInput(formattedNumber, { number, isValid, country }) {
      this.phoneData = {
        number: number,
        countryCode: country && country.dialCode ? `+${country.dialCode}` : null,
        isValid: isValid,
        formatted: formattedNumber
      };

      // Limpiar mensajes de error
      if (this.phoneError) {
        this.phoneError = null;
      }
    },
    detectBrowser() {
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf('edge') > -1) return 'edge';
      if (userAgent.indexOf('chrome') > -1 && userAgent.indexOf('edg') === -1) return 'chrome';
      if (userAgent.indexOf('firefox') > -1) return 'firefox';
      if (userAgent.indexOf('safari') > -1 && userAgent.indexOf('chrome') === -1) return 'safari';
      return 'other';
    },
    requestGeolocation() {
      if (!this.locationStatus.supported) {
        return;
      }

      this.locationStatus.isLoading = true;
      this.locationStatus.error = null;

      const options = {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      };

      navigator.geolocation.getCurrentPosition(
        this.handleGeolocationSuccess,
        this.handleGeolocationError,
        options
      );
    },
    handleGeolocationSuccess(position) {
      this.location.latitude = position.coords.latitude;
      this.location.longitude = position.coords.longitude;
      this.location.accuracy = position.coords.accuracy;

      this.locationStatus.isLoading = false;
      this.locationStatus.permissionDenied = false;
      this.locationStatus.error = null;

      console.log("Ubicación obtenida:", this.location);

      // Notificar al usuario que la ubicación se obtuvo correctamente
      this.$vs.notify({
        color: 'success',
        title: 'Ubicación detectada',
        text: 'Su ubicación ha sido detectada correctamente.',
        position: 'top-center',
        time: 3000
      });
    },
    handleGeolocationError(error) {
      this.locationStatus.isLoading = false;

      switch(error.code) {
        case error.PERMISSION_DENIED:
          this.locationStatus.permissionDenied = true;
          this.locationStatus.error = "Para continuar con el proceso de firma, es necesario permitir el acceso a su ubicación.";
          console.error("User denied the request for Geolocation.");
          break;
        case error.POSITION_UNAVAILABLE:
          this.locationStatus.error = "La información de ubicación no está disponible. Por favor, intente nuevamente.";
          console.error("Location information is unavailable.");
          break;
        case error.TIMEOUT:
          this.locationStatus.error = "La solicitud de ubicación ha expirado. Por favor, intente nuevamente.";
          console.error("The request to get user location timed out.");
          break;
        default:
          this.locationStatus.error = "Ha ocurrido un error al obtener su ubicación. Por favor, intente nuevamente.";
          console.error("An unknown error occurred getting location:", error);
          break;
      }

      // Si el permiso fue denegado, mostrar diálogo con instrucciones
      if (this.locationStatus.permissionDenied) {
        this.promptGeolocationPermission();
      }
    },
    promptGeolocationPermission() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Se requiere su ubicación',
        text: 'Para continuar con el proceso de firma, es necesario permitir el acceso a su ubicación. Los permisos de ubicación ayudan a validar la autenticidad de su firma y son un requisito legal para este tipo de documento.',
        acceptText: 'Ver instrucciones',
        cancelText: 'Cancelar proceso',
        accept: () => {
          // Al aceptar, mostrar el componente de instrucciones
          this.showGeolocationModal = true;
        },
        cancel: () => {
          // Si el usuario cancela, mostrar diálogo de confirmación de cancelación
          this.cancelVerification();
        }
      });
    },
    closeGeolocationInstructions() {
      this.showGeolocationModal = false;
    },
    reloadPage() {
      window.location.reload();
    },
    checkPreConfiguredPhone() {
      this.$store.dispatch("documentVerify/getLocalVerification", {
        uuid: this.uuid,
        signatureId: this.signatureId,
        signatureFlowId: this.signatureFlowId
      }).then(
        localVerification => {
          if (localVerification && localVerification.data[0].attributes.phoneNumber) {
            // Obtener el teléfono preconfigurado
            const phoneNumber = localVerification.data[0].attributes.phoneNumber;

            // Verificar si el número ya incluye código de país
            if (phoneNumber.startsWith('+')) {
              // Si ya tiene código de país, lo usamos directamente
              this.phoneData.formatted = phoneNumber;

              // Extraer el código de país para configurar correctamente el componente
              // El formato típico sería +52 1234567890
              const countryCodeMatch = phoneNumber.match(/^\+(\d+)/);
              if (countryCodeMatch && countryCodeMatch[1]) {
                this.phoneData.countryCode = `+${countryCodeMatch[1]}`;

                // La librería necesita que inicialicemos estos valores
                this.phoneData.isValid = true;

                // También podemos extraer el número sin el código para una mejor visualización
                // pero esto es manejado automáticamente por el componente vue-tel-input
              }
            } else {
              // Si no incluye código de país, asumimos el predeterminado (México +52)
              this.phoneData.formatted = `+52 ${phoneNumber}`;
              this.phoneData.countryCode = '+52';
              this.phoneData.isValid = true;
            }
          }

          if (localVerification && localVerification.data[0].attributes.config.lock_phone_for_otp) {
            if (this.phoneData.formatted) {
              this.isPhoneConfigured = true;
            }
          }
          this.locationStatus.isRequired = true;
        }
      ).catch(error => {
        console.error("Error al obtener el teléfono preconfigurado:", error);
        // Failsafe: Si hay error, permitir al usuario ingresar su número
        this.isPhoneConfigured = false;
      });
    },
    sendOtp() {
      if (!this.validPhone) {
        this.phoneError = "Por favor, ingrese un número de teléfono válido";
        return;
      }

      // Verificar si tenemos la ubicación si es requerida
      if (this.locationStatus.isRequired && (!this.location.latitude || !this.location.longitude)) {
        if (this.locationStatus.permissionDenied) {
          this.showGeolocationModal = true;
          return;
        } else if (this.locationStatus.error) {
          // Intentar nuevamente
          this.$vs.dialog({
            type: 'confirm',
            color: 'warning',
            title: 'Ubicación no disponible',
            text: 'No hemos podido detectar su ubicación, la cual es necesaria para continuar. ¿Desea intentar nuevamente?',
            acceptText: 'Intentar nuevamente',
            cancelText: 'Cancelar',
            accept: () => {
              this.requestGeolocation();
            }
          });
          return;
        }
      }

      this.isVerifying = true;
      this.phoneError = null;

      // Preparar payload que incluye la ubicación si está disponible
      const payload = {
        uuid: this.uuid,
        signatureId: this.signatureId,
        signatureFlowId: this.signatureFlowId,
        phoneNumber: this.phoneData.formatted // Usamos el número formateado
      };

      // Añadir la ubicación al payload si está disponible
      if (this.location.latitude && this.location.longitude) {
        payload.geolocation = {
          latitude: this.location.latitude,
          longitude: this.location.longitude,
          accuracy: this.location.accuracy
        };
      }

      // Enviar solicitud a la API
      this.$store.dispatch("documentVerify/sendOtp", payload)
        .then(response => {
          this.showOtpInput = true;
          this.startResendTimer();
          this.resetOtp(); // Limpiar el OTP si se reenvía
          this.$nextTick(() => {
            // Enfocar el primer input de OTP
            if (this.$refs.otpInput0 && this.$refs.otpInput0[0]) {
              console.log(this.$refs.otpInput0)
              this.$refs.otpInput0[0].focusInput();
            }
          });
        })
        .catch(error => {
          this.phoneError = error || "Error al enviar el código. Intente nuevamente.";
        })
        .finally(() => {
          this.isVerifying = false;
        });
    },
    isOtpComplete() {
      return this.otp.every(digit => digit !== '');
    },
    verifyOtp() {
      if (!this.isOtpComplete()) {
        this.otpError = "Por favor, ingrese el código de 6 dígitos completo";
        return;
      }

      if (!this.location.latitude || !this.location.longitude) {
        this.otpError = "Ubicación no disponible. Por favor, permita el acceso a su ubicación.";
        return;
      }

      this.isVerifying = true;
      this.otpError = null;

      const otpCode = this.otp.join('');

      // Preparar payload que incluye la ubicación si está disponible
      const payload = {
        uuid: this.uuid,
        signatureId: this.signatureId,
        signatureFlowId: this.signatureFlowId,
        otp: otpCode,
        latitude: this.location.latitude,
        longitude: this.location.longitude,
        name: "",
        curp: "",
      };

      // Llamada a la API
      this.$store.dispatch("documentVerify/verifyOtp", payload)
        .then(response => {
          // Mostrar mensaje de éxito brevemente
          this.successMessage = "Verificación exitosa. Continuando...";
          this.isSubmitted = true;
          this.$router.push({
            name: 'page-signature-flow',
            params: {
              uuid: this.signatureId,
              signatureFlowId: this.signatureFlowId
            }
          });
        })
        .catch(error => {
          this.otpError = (error) ? error : "Código inválido. Por favor, verifique e intente nuevamente.";
          this.$vs.notify({
            color: 'danger',
            title: 'Código inválido',
            text: this.otpError,
            position: 'top-center',
            time: 5000
          });
          this.resetOtp(); // Opcional: limpiar el OTP en caso de error
        })
        .finally(() => {
          this.isVerifying = false;
        });
    },
    focusNext(index) {
      // Limpiar caracteres no numéricos
      this.otp[index] = this.otp[index].replace(/\D/g, '');

      // Si hay un valor y no es el último campo, pasar al siguiente
      if (this.otp[index] !== '' && index < 5) {
        this.$nextTick(() => {
          if (this.$refs[`otpInput${index + 1}`] && this.$refs[`otpInput${index + 1}`][0]) {
            this.$refs[`otpInput${index + 1}`][0].focusInput();
          }
        });
      }

      // Si se completaron todos los dígitos, verificar automáticamente
      if (this.otpComplete) {
        this.verifyOtp();
      }
    },
    focusPrev(index, event) {
      // Si se presiona backspace en un campo vacío, retroceder al anterior
      if (event.key === 'Backspace' && this.otp[index] === '' && index > 0) {
        this.$nextTick(() => {
          if (this.$refs[`otpInput${index - 1}`] && this.$refs[`otpInput${index - 1}`][0]) {
            this.$refs[`otpInput${index - 1}`][0].focusInput();
          }
        });
      }
    },
    handlePaste(event) {
      event.preventDefault();
      // Obtener texto del portapapeles
      const clipboardData = event.clipboardData || window.clipboardData;
      const pastedData = clipboardData.getData('Text');

      // Filtrar solo números
      const numbers = pastedData.replace(/\D/g, '');

      // Llenar los campos de OTP con los números pegados
      for (let i = 0; i < Math.min(numbers.length, 6); i++) {
        this.otp[i] = numbers[i];
      }

      // Si se pegaron 6 dígitos, verificar automáticamente
      if (this.isOtpComplete()) {
        this.verifyOtp();
      } else if (numbers.length > 0) {
        // Enfocar el siguiente campo vacío
        for (let i = 0; i < 6; i++) {
          if (!this.otp[i]) {
            this.$nextTick(() => {
              if (this.$refs[`otpInput${i}`] && this.$refs[`otpInput${i}`][0]) {
                this.$refs[`otpInput${i}`][0].focusInput();
              }
            });
            break;
          }
        }
      }
    },
    startResendTimer() {
      this.resendTimer = 60; // 60 segundos para reenviar
      this.canResend = false;

      clearInterval(this.timerInterval);
      this.timerInterval = setInterval(() => {
        if (this.resendTimer > 0) {
          this.resendTimer--;
        } else {
          this.canResend = true;
          clearInterval(this.timerInterval);
        }
      }, 1000);
    },
    resendOtp() {
      if (this.canResend) {
        this.sendOtp();
      }
    },
    resetOtp() {
      this.otp = ['', '', '', '', '', ''];
      this.otpError = null;
      this.$nextTick(() => {
        if (this.$refs.otpInput0 && this.$refs.otpInput0[0]) {
          this.$refs.otpInput0[0].focusInput();
        }
      });
    },
    cancelVerification() {
      // Confirmar si desea cancelar
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmar cancelación',
        text: '¿Está seguro que desea cancelar el proceso de verificación?',
        acceptText: 'Sí, cancelar',
        cancelText: 'No, continuar',
        accept: () => {
          // Redirigir o volver a la página anterior
          this.$router.push({ name: 'home' }); // Ajustar a tu ruta correspondiente
        }
      });
    }
  },
  beforeDestroy() {
    // Limpiar intervalo al destruir el componente
    clearInterval(this.timerInterval);
  }
}
</script>

<template>
  <transition name="bounce">
    <div class="container">
      <!-- Componente modal de instrucciones de geolocalización -->
      <GeolocationInstructions
        :isVisible="showGeolocationModal"
        :browser="currentBrowser"
        :isMobile="isMobileDevice"
        @close="closeGeolocationInstructions"
        @reload="reloadPage"
      />

      <navBar/>
      <transition :name="routerTransition">
        <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap items-center mb-6">
          <div
            class="content-area__heading"
            :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">
            <h2 class="mb-1 mt-0">Firma autógrafa</h2>
          </div>

          <!-- BREADCRUMB -->
          <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" :route="$route" :isRTL="$vs.rtl" />
        </div>
      </transition>

      <div class="vx-card p-6">
        <div class="mb-6 text-center">
          <h3 class="text-xl font-medium mb-2">Verificación de teléfono</h3>
          <p class="text-gray-600">Para continuar con el proceso de firma, necesitamos verificar su teléfono.</p>
        </div>

        <!-- Alerta de Geolocalización -->
        <div v-if="locationStatus.isRequired && locationStatus.error" class="mb-4">
          <vs-alert
            active="true"
            color="warning"
          >
            <feather-icon
              icon="AlertTriangleIcon"
              svgClasses="h-6 w-6 stroke-current text-warning"
              class="mr-2"
            />
            <span>{{ locationStatus.error }}</span>
            <div class="mt-3 flex items-center justify-center" v-if="locationStatus.permissionDenied">
              <vs-button color="primary" type="flat" @click="showGeolocationModal = true" class="mr-2">
                Ver instrucciones
              </vs-button>
              <vs-button color="dark" type="flat" @click="reloadPage">
                Recargar página
              </vs-button>
            </div>
          </vs-alert>
        </div>

        <!-- Estado de Geolocalización -->
        <div v-if="locationStatus.isRequired && location.latitude && location.longitude" class="mb-4 flex justify-center">
          <vs-chip color="success" icon="check_circle">
            Ubicación detectada correctamente
          </vs-chip>
        </div>

        <!-- Indicador de carga para geolocalización -->
        <div v-if="locationStatus.isLoading" class="mb-4 flex justify-center">
          <vs-chip color="primary">
            <vs-avatar>
              <div class="spinner"></div>
            </vs-avatar>
            Obteniendo su ubicación...
          </vs-chip>
        </div>

        <!-- Phone Number Section -->
        <div v-if="!showOtpInput" class="mb-6 flex justify-center">
          <div class="w-full max-w-md">
            <div class="form-group">
              <label class="mb-2 block text-center">Número de teléfono</label>

              <!-- Componente de teléfono con banderas -->
              <div class="phone-input-container">
                <vue-tel-input
                  v-model="phoneData.formatted"
                  :disabled="isPhoneConfigured"
                  @input="onPhoneInput"
                  :inputOptions="telInputOptions.inputOptions"
                  :defaultCountry="telInputOptions.defaultCountry"
                  :enabledFlags="telInputOptions.enabledFlags"
                  :enabledCountryCode="telInputOptions.enabledCountryCode"
                  :preferredCountries="telInputOptions.preferredCountries"
                  :onlyCountries="telInputOptions.onlyCountries"
                  :invalidMsg="telInputOptions.invalidMsg"
                  :mode="telInputOptions.mode"
                  :autocomplete="'tel'"
                  :inputClasses="{'input-error': !!phoneError}"
                  :dropdownOptions="{showDialCodeInSelection: true}"
                  class="vue-tel-input-custom"
                />
              </div>

              <p v-if="phoneError" class="text-danger text-sm mt-1">{{ phoneError }}</p>

              <p v-if="isPhoneConfigured" class="text-sm text-gray-500 mt-1 text-center">
                Este número fue configurado para este firmante del documento y no puede ser manipulado.
              </p>
            </div>

            <div class="mt-6 flex justify-center space-x-4">
              <vs-button
                type="filled"
                @click="sendOtp"
                :disabled="isVerifying || !validPhone || (locationStatus.isRequired && locationStatus.permissionDenied && !location.latitude)"
                :loading="isVerifying"
              >
                Enviar código de verificación
              </vs-button>

              <vs-button
                type="border"
                color="danger"
                @click="cancelVerification"
              >
                Cancelar
              </vs-button>
            </div>

            <!-- Si la ubicación es requerida pero no está disponible -->
            <div v-if="locationStatus.isRequired && locationStatus.permissionDenied && !location.latitude" class="mt-4 text-center">
              <p class="text-sm text-danger">
                Se requiere su ubicación para continuar. Por favor, habilite el acceso.
              </p>
              <div class="mt-2">
                <a href="#" @click.prevent="showGeolocationModal = true" class="text-sm text-primary hover:underline">
                  Ver instrucciones para habilitar ubicación
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- OTP Input Section -->
        <div v-if="showOtpInput" class="mb-6 flex justify-center">
          <div class="w-full max-w-md text-center">
            <div class="mb-4">
              <p class="mb-2">Hemos enviado un código de verificación al número:</p>
              <p class="font-medium">{{ formattedPhone }}</p>
              <p class="text-sm text-gray-500 mt-1">
                Ingrese el código de 6 dígitos a continuación.
              </p>
            </div>

            <div class="flex justify-center mb-4">
              <div
                class="otp-inputs flex space-x-3"
              >
                <vs-input
                  @paste="handlePaste"
                  v-for="(digit, index) in otp"
                  :key="index"
                  v-model="otp[index]"
                  :ref="`otpInput${index}`"
                  class="otp-input"
                  maxlength="1"
                  type="text"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  @input="focusNext(index)"
                  @keydown="focusPrev(index, $event)"
                  style="width: 50px; text-align: center; font-size: 1.25rem; font-weight: bold;"
                />
              </div>
            </div>

            <p v-if="otpError" class="text-danger text-center mb-4">{{ otpError }}</p>
            <p v-if="successMessage" class="text-success text-center mb-4">{{ successMessage }}</p>

            <div class="flex flex-col items-center">
              <div class="flex justify-center mb-3">
                <vs-button
                  type="filled"
                  @click="verifyOtp"
                  :disabled="!otpComplete || isVerifying"
                  :loading="isVerifying"
                  class="mr-3"
                >
                  Verificar
                </vs-button>
                <vs-button type="border" @click="showOtpInput = false" class="ml-3">Cambiar número</vs-button>
              </div>

              <div class="mt-4 text-center">
                <p v-if="!canResend" class="text-sm text-gray-500">
                  Reenviar código en {{ resendTimer }} segundos
                </p>
                <a
                  v-else
                  href="#"
                  @click.prevent="resendOtp"
                  class="text-sm text-primary cursor-pointer hover:underline"
                >
                  Reenviar código
                </a>
              </div>

              <div class="mt-3 flex space-x-4 justify-center">
                <a
                  href="#"
                  @click.prevent="resetOtp"
                  class="text-sm text-gray-600 cursor-pointer hover:underline"
                >
                  Limpiar código
                </a>

                <a
                  href="#"
                  @click.prevent="cancelVerification"
                  class="text-sm text-danger cursor-pointer hover:underline"
                >
                  Cancelar verificación
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped lang="scss">
.loading-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.9);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.otp-input {
  border-radius: 8px;
  transition: all 0.2s;
}

.otp-input input {
  text-align: center;
  font-size: 1.25rem !important;
  font-weight: bold;
}

.text-danger {
  color: #e74c3c;
}

.text-success {
  color: #2ecc71;
}

.text-primary {
  color: #4173FF;
}

.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Animación de bounce */
.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

/* Estilos específicos para vue-tel-input */
.vue-tel-input-custom {
  border-radius: 4px;
  border: 1px solid #ccc;
  font-family: inherit;
  width: 100%;
}

.vue-tel-input-custom.vue-tel-input-focused {
  border-color: #4173FF;
  box-shadow: 0 0 0 0.2rem rgba(65, 115, 255, 0.25);
}

.vue-tel-input-custom.input-error {
  border-color: #e74c3c;
  box-shadow: 0 0 0 0.2rem rgba(231, 76, 60, 0.25);
}

.phone-input-container {
  margin-bottom: 1rem;
}

/* Mejoras para el dropdown de países */
:deep(.vti__dropdown) {
  border-radius: 4px 0 0 4px;
  transition: all 0.3s ease;
}

:deep(.vti__dropdown:hover) {
  background-color: #f8f9fa;
}

:deep(.vti__dropdown-list) {
  max-height: 240px;
  overflow-y: auto;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border: 1px solid #e1e4e8;
}

:deep(.vti__dropdown-list-item) {
  padding: 10px 10px;
  transition: background-color 0.2s;
}

:deep(.vti__dropdown-list-item:hover) {
  background-color: #f1f5f9;
}

:deep(.vti__dropdown-list-item.highlighted) {
  background-color: #e6f0ff;
}

/* Deshabilitar estilos cuando el input está deshabilitado */
:deep(.vue-tel-input-disabled .vti__input) {
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.7;
}

:deep(.vue-tel-input-disabled .vti__dropdown) {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Mejoras para inputs en dispositivos móviles */
@media (max-width: 768px) {
  :deep(.vti__input) {
    padding: 10px 12px;
    font-size: 16px; /* Evita zoom en dispositivos iOS */
  }

  :deep(.vti__dropdown) {
    padding: 10px 0;
  }
}
</style>
